import React, {useState, useEffect} from 'react'
import {PostData} from '../Services/httpHandelars'
import { useNavigate } from 'react-router-dom'
import { LockClosedIcon } from '@heroicons/react/solid'
import { useGlobalContext } from '../context'
import Snackbar from '../Components/Snackbar'
import Loader from '../Components/Loader'

const Login = () => {

  
  const [form, setForm] = useState({loginID:"", password:"",})
  const [snacBar, setSnacBar ]= useState({snacStatus: false, message:"", snackType:""})
  const [showPassword, setShowPassword] = useState(false) 
  
  const {setUser, setLoading, loading} = useGlobalContext();
  

  useEffect(
    () => {
        if (snacBar.snacStatus === true) {
            setTimeout(() => setSnacBar(false), 3000);
        }
    },

    [snacBar.snacStatus]
);

  


    const handleClickShowPassword = () =>{
      setShowPassword(showPassword => !showPassword)
    }

  const handleChange = (e) =>{
    setForm({...form, [e.target.name]: e.target.value })
    
  }
  const navigate = useNavigate();

  
  const handleSubmit = () => {

    // setLoading(true)
    const data = {
      LoginID: form.loginID,
      Password: form.password
    }
    PostData("/api/user/login", data).then((data) => {
      if(data.status === true){
        setSnacBar({...snacBar, 
          snacStatus: data.status,
          message:data.message,
          snackType:"Success"
        })
        navigate('/');
      }else{
        setSnacBar({...snacBar, 
          snacStatus: true,
          message: data?.message || "Responce Failed",
          snackType:"Error"
        })

      }
      setUser(data)
    })
    .catch((e) => {
        setSnacBar({...snacBar, 
          snacStatus: true,
          message:"Responce Failed",
          snackType:"Error"
        })

    });
  }
  return  <>
    {!loading ?
   
   <>
      <div className='h-screen' style={{backgroundImage: "url('/images/Background.png')", minHeight: "100%",minWidth: "100%", backgroundPosition: "center", objectFit: "cover",    backgroundSize: "cover", backgroundPosition: "6% 0%" }} >
       <div className = " h-full flex items-center justify-end py-12 px-4 sm:px-6 sm:mr-12 lg:px-12 xl:mr-11">
        <div className="max-w-md w-full space-y-8  p-4 rounded-xl  ">
          <div>
            <h2 className=" text-center text-3xl tracking-tight font-bold text-white">
              Sign in to your account
            </h2>
          </div>
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Login ID
                </label>
                <input
                  id="email-address"
                  name="loginID"
                  value={form.loginID}
                  type="text"
                  onChange={handleChange}
                  autoComplete="email"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Login ID"
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type= {showPassword ?  "text" : "password" }
                  value={form.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                  required
                  className="appearance-none rounded-none  block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Password"
                />
                
                
                {/* <div
                 
                  onClick={handleClickShowPassword}
                > */}
                  {showPassword ? (
                  <span onClick={handleClickShowPassword} className="absolute -top-3 bottom-0 flex flex-col right-32 justify-center items-end ">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>

                  </span>
                  ) : (
                    <span onClick={handleClickShowPassword} className="absolute -top-3 bottom-0 flex flex-col right-32 justify-center items-end ">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>

                  </span>

                  )} 
                {/* </div> */}
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-white">
                  Remember me
                </label>
              </div>

              <div className="text-sm">
                <button onClick={()=>navigate('/forgetpassword')} className="font-medium text-black hover:text-white">
                  Forgot your password?
                </button>
              </div>
            </div>

            <div>
              <button
                onClick={handleSubmit}
               
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                style={{backgroundColor:"rgb(0 132 0)"}}
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <LockClosedIcon className="h-5 w-5 text-white" aria-hidden="true" />
                </span>
                Sign in
              </button>
            </div>
        </div>
        </div> 
        {snacBar?.snacStatus &&
          <div>
          <Snackbar snackType={snacBar.snackType} message={snacBar.message} status={snacBar.snacStatus} setSnacBar={setSnacBar}/>
          </div>
          }
      </div>
       </>
     : <Loader />} </>
  
}

export default Login